import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../styles/theme/foundation/colors';

function InputCaption({ caption, error }) {
  let captionColor;
  let captionMessage;
  let visibility = 'visible';

  const captionStatus = error ? 'error' : caption ? 'hidden' : 'info';

  if (error) {
    captionMessage = error.message;
    captionColor = colors.error.primary['600'];
  }

  if (caption && !error) {
    captionMessage = caption;
    captionColor = colors.greyScale['500'];
  }

  if (!caption && !error) {
    captionMessage = 'empty';
    visibility = 'hidden';
  }

  return (
    <Box
      justifyContent="flex-start"
      mb="5px"
      mt="5px !important"
      textAlign="left"
      visibility={visibility}
      width="100%"
    >
      <Text
        color={captionColor}
        dusk={`caption-${captionStatus}`}
        textStyle="bodyXs500"
      >
        {captionMessage}
      </Text>
    </Box>
  );
}

InputCaption.propTypes = {
  caption: PropTypes.string.isRequired,
  error: PropTypes.shape({
    message: PropTypes.string
  })
};

export default InputCaption;
